/*
 * Removes the duplicate Product structured data that REVIEWS.io injects.
 *
 * Their Product Reviews Widget writes its own Product JSON-LD into the head
 * on any product that has a review, under the id below. We checked the whole
 * widget editor on 1 Nov 2026: there is no setting to turn that markup off.
 * The only structured data option is "Include Q&A in structured data". So the
 * markup and the visible reviews are the same feature, and switching it off
 * would take the reviews off the page.
 *
 * That left two Product entities on one page, each missing what the other
 * had. Theirs carried the rating and the GTIN but no brand, shipping or
 * returns. Ours carried brand, shipping and returns but neither of the first
 * two. Google asks you to pick one, and it might well have picked the half
 * without the shipping and returns, on exactly the products most likely to
 * earn a rich result.
 *
 * The theme's own block now carries all of it, reading the rating from the
 * metafields REVIEWS.io writes, so theirs is pure duplication and this
 * removes it. The widget itself is untouched: reviews still display.
 *
 * If REVIEWS.io ever renames that element this quietly stops working and the
 * duplicate comes back, which is the situation we are in today rather than a
 * new fault. Worth re-checking a product page's structured data if Search
 * Console starts reporting duplicate products again.
 */
(function () {
  'use strict';

  var SNIPPET_ID = 'reviewsWidgetProductSnippets';

  function removeDuplicate() {
    var duplicate = document.getElementById(SNIPPET_ID);
    if (!duplicate) return false;
    duplicate.parentNode.removeChild(duplicate);
    return true;
  }

  removeDuplicate();

  /*
   * The widget injects into the head after load, so watching the head's own
   * children catches it. Deliberately not observing the whole document with
   * subtree: this page already runs a lot of script and that would be a cost
   * on every DOM change for the sake of one element.
   */
  if (window.MutationObserver && document.head) {
    var observer = new MutationObserver(function () {
      removeDuplicate();
    });

    observer.observe(document.head, { childList: true });

    // Nothing injects this late. Stop watching rather than leave an observer
    // running for the life of the page.
    window.setTimeout(function () {
      observer.disconnect();
      removeDuplicate();
    }, 15000);
  }

  // Backstop for the case where it lands somewhere other than the head.
  [1000, 3000, 6000].forEach(function (delay) {
    window.setTimeout(removeDuplicate, delay);
  });
})();
